export default __webpack_public_path__ + "static/media/k_wdt_c_6.d4c051e0.mp3";